module.exports = __webpack_public_path__ + "img/Galactapedia_Tumbril_Land_Systems.c1864cf2.png";